import React from "react";
import styles from "../assets/styles/main.module.css";
import Strings from "../utils/stringUtil";
import { Box, Typography } from "@mui/material";
import theme from "../utils/themeUtil";
import TextSize from "../utils/textSizeUtil";
import { isMobile } from "../utils/responsiveUtil";
import Seo from "../components/seo";
import withLoader from "../components/ui/withLoader";

function CookiePolicy() {
  return (
    <React.Fragment>
      <Seo
        title={Strings.cookiePolicyMetaTitle}
        description={Strings.cookiePolicyMetaDescription}
        keywords={Strings.cookiePolicyMetaKeyword}
      />
      <Box mt={5}>
        <Box className={styles.container}>
          <Box textAlign="left" my={isMobile ? 2 : 5}>
            <Typography
              style={{
                fontSize: TextSize.size24,
                fontWeight: "bold",
                color: theme.palette.black.main,
              }}
            >
              {Strings.cookiePolicy}
            </Typography>
          </Box>
          <Box
            style={{ fontSize: "14px", textAlign: "left" }}
            dangerouslySetInnerHTML={{ __html: Strings.cookiePolicyContent }}
          ></Box>
        </Box>
      </Box>
    </React.Fragment>
  );
}

export default withLoader(CookiePolicy);
